import './app.css';

import {createRoot} from 'react-dom/client';
import {CommonProvider} from '@common/core/common-provider';
import {rootEl} from '@common/core/root-el';
import {getBootstrapData} from '@common/core/bootstrap-data/use-backend-bootstrap-data';
// import {UserLink} from '@app/profile/user-link';
// import {UserProfile} from '@app/profile/user-profile';
// import {LandingPageContent} from '@app/landing-page/landing-page-content';
import {BrowserRouter} from 'react-router-dom';
import {AppRoutes} from '@app/app-routes';
// import { UseWatchPageVideoResponse } from '@app/videos/requests/use-watch-page-video';

// todo: don't include title description in homepage channel, except for slider channel, skip other not needed data as well to reduce payload size
// todo: slice description on php side, instead of client in channel slider

declare module '@common/core/bootstrap-data/bootstrap-data' {
    interface BootstrapData {
        loaders: {
            customPage?: any;
            // watchPageVideo?: UseWatchPageVideoResponse;}
        };
    }
}

// declare module '@common/auth/user' {
//   interface User {
//   }
// }

const data = getBootstrapData();


const app = (
    <BrowserRouter basename={data.settings.html_base_uri}>
        <CommonProvider>
            <AppRoutes />
        </CommonProvider>
    </BrowserRouter>
);

createRoot(rootEl).render(app);
